import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

declare const MediaRecorder: any;
interface IRecord {
  data: Blob;
}

@Component({
  selector: 'app-record-video-dialog',
  templateUrl: './record-video-dialog.component.html',
  styleUrls: ['./record-video-dialog.component.sass'],
})
export class RecordVideoDialogComponent implements OnInit {
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  mediaRecorder!: any;
  recordedChunks: Blob[] = [];
  isRecordingInProgress = false;
  isPaused = false;
  isProcessing = false;
  timer = 0;
  private timerInterval: any;
  private recordedBlob: Blob;
  videoUrl: string;

  constructor(private dialogRef: MatDialogRef<RecordVideoDialogComponent>) {}

  ngOnInit(): void {
    this.initializeVideoStream();
  }

  initializeVideoStream() {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        this.videoElement.nativeElement.srcObject = stream;
        this.mediaRecorder = new MediaRecorder(stream, { mimeType: 'video/webm' });
        this.mediaRecorder.ondataavailable = (event: IRecord) => {
          if (event.data.size > 0) {
            this.recordedChunks.push(event.data);
          }
        };
        this.mediaRecorder.onstop = () => {
          if (this.isRecordingInProgress) {
            this.processRecording();
          }
        };
      })
      .catch((error) => console.error('Error-Camera:', error));
  }

  startRecording() {
    if (!this.isRecordingInProgress) {
      this.isRecordingInProgress = true;
      this.isPaused = false;
      this.recordedChunks = [];
      this.mediaRecorder.start(100);
      this.startTimer();
    }
  }

  pauseRecording() {
    if (this.isRecordingInProgress) {
      this.isRecordingInProgress = false;
      this.isProcessing = true;
      this.mediaRecorder.stop();
      clearInterval(this.timerInterval);
      this.saveVideo();
    }
  }

  processRecording() {
    this.isProcessing = false;
  }

  saveVideo() {
    this.recordedBlob = new Blob(this.recordedChunks, { type: 'video/webm' });
    const filename = `evidencia_gravacao_${Math.random().toString(36).substring(2, 7)}_${new Date()
      .toISOString()
      .replace(/[:.]/g, '-')}.webm`;

    const videoFile = new File([this.recordedBlob], filename, { type: 'video/webm' });

    this.videoUrl = URL.createObjectURL(videoFile);

    setTimeout(() => {
      this.isProcessing = false;
    }, 2000);
  }

  discardVideo() {
    this.resetRecordingState();
  }

  applyVideo() {
    const filename = `evidencia_gravacao_${Math.random().toString(36).substring(2, 7)}_${new Date()
      .toISOString()
      .replace(/[:.]/g, '-')}.webm`;

    const videoFile = new File([this.recordedBlob], filename, { type: 'video/webm' });

    this.isProcessing = true;

    setTimeout(() => {
      this.isProcessing = false;
      this.dialogRef.close(videoFile);
    }, 2000);
  }

  resetRecordingState() {
    this.recordedChunks = [];
    this.isPaused = false;
    this.isRecordingInProgress = false;
    this.isProcessing = false;
    this.timer = 0;
    clearInterval(this.timerInterval);
  }

  private startTimer() {
    this.timerInterval = setInterval(() => this.timer++, 1000);
  }
}
